// Mode1996Toggle.js
class Mode1996Toggle {
    constructor(options = {}) {
        // Config
        this.cookieName = options.cookieName || 'mode1996'
        this.cookieDays = options.cookieDays || 365
        this.enabledClass = options.enabledClass || 'mode-1996'
        this.enableSelector = options.enableSelector || null
        this.disableSelector = options.disableSelector || null

        // Elements
        this.html = document.documentElement
        this.enableBtn = this.enableSelector
            ? document.querySelector(this.enableSelector)
            : null
        this.disableBtn = this.disableSelector
            ? document.querySelector(this.disableSelector)
            : null

        this.init()
    }

    /* ---------- Cookies ---------- */

    setCookie(value) {
        const date = new Date()
        date.setTime(date.getTime() + this.cookieDays * 86400000)
        document.cookie =
            this.cookieName +
            '=' +
            value +
            '; expires=' +
            date.toUTCString() +
            '; path=/'
    }

    getCookie() {
        return document.cookie
            .split('; ')
            .find(row => row.startsWith(this.cookieName + '='))
            ?.split('=')[1]
    }

    deleteCookie() {
        document.cookie = this.cookieName + '=; Max-Age=0; path=/'
    }

    /* ---------- State ---------- */

    enable(reload = true) {
        this.setCookie('true')
        if (reload) location.reload()
        else this.applyEnabledState()
    }

    disable(reload = true) {
        this.deleteCookie()
        if (reload) location.reload()
        else this.applyDisabledState()
    }

    applyEnabledState() {
        this.html.classList.add(this.enabledClass)
        if (this.enableBtn) this.enableBtn.style.display = 'none'
        if (this.disableBtn) this.disableBtn.style.display = 'block'
    }

    applyDisabledState() {
        this.html.classList.remove(this.enabledClass)
        if (this.disableBtn) this.disableBtn.style.display = 'none'
        if (this.enableBtn) this.enableBtn.style.display = 'block'
    }

    /* ---------- Init ---------- */

    init() {
        if (this.enableBtn) {
            this.enableBtn.addEventListener('click', () => this.enable())
        }

        if (this.disableBtn) {
            this.disableBtn.addEventListener('click', () => this.disable())
        }

        // Init without reload
        if (this.getCookie() === 'true') {
            this.applyEnabledState()
        } else {
            this.applyDisabledState()
        }
    }
}

new Mode1996Toggle({
    enableSelector: '#mode1996-enable',
    disableSelector: '#mode1996-disable'
})


new Mode1996Toggle({
    enableSelector: '.enable-1996',
    disableSelector: '.disable-1996'
})